// app/javascript/controllers/navigation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "panel"]
  static values  = {
    toggleClass: { type: String, default: "hidden" },
    activeClass: { type: String, default: "open" }
  }

  connect() {
    this._clickAway = this._clickAway.bind(this)
    document.addEventListener("click", this._clickAway)
  }

  disconnect() {
    document.removeEventListener("click", this._clickAway)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const btn   = event.currentTarget
    const id    = btn.dataset.navigationIdValue
    const panel = this.panelTargets.find(p => p.dataset.navigationIdValue === id)
    const wasOpen = !panel.classList.contains(this.toggleClassValue)

    this._closeAll()

    if (!wasOpen) {
      btn.classList.add(this.activeClassValue)
      panel.classList.remove(this.toggleClassValue)
      if (id === "mobile") document.body.classList.add("overflow-hidden")
    }
  }

  _closeAll() {
    this.triggerTargets.forEach(t => t.classList.remove(this.activeClassValue))
    this.panelTargets.forEach(p => p.classList.add(this.toggleClassValue))
    document.body.classList.remove("overflow-hidden")
    this.dispatch("closeall", { bubbles: true })
  }

  _clickAway(e) {
    if (!this.element.contains(e.target)) {
      this._closeAll()
    }
  }
}